interface AppleIconProps {
    color?: string;
    className?: string | null;
}

function AppleIcon({ color = 'currentColor', className = null }: AppleIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="13px"
            height="16px"
            viewBox="0 0 13 16"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <g>
                <g>
                    <path
                        fill={color}
                        d="M9.6,0c0,0,0.1,0,0.1,0c0.1,1.1-0.3,2-0.9,2.6C8.3,3.2,7.6,3.8,6.5,3.7C6.4,2.6,6.9,1.8,7.4,1.2
			C7.9,0.6,8.7,0.1,9.6,0z"
                    />
                    <path
                        fill={color}
                        d="M13,11.7C13,11.8,13,11.8,13,11.7c-0.3,1-0.8,1.8-1.3,2.6C11.2,15,10.6,16,9.5,16c-1,0-1.6-0.6-2.6-0.6
			c-1,0-1.6,0.5-2.6,0.7c-0.1,0-0.2,0-0.3,0c-0.7-0.1-1.3-0.7-1.7-1.2C1.1,13.4,0.2,11.5,0,9c0-0.2,0-0.5,0-0.7
			c0.1-1.7,0.9-3.2,2-3.8c0.6-0.4,1.4-0.7,2.3-0.5C4.8,4,5.2,4.1,5.5,4.3c0.3,0.1,0.7,0.4,1.1,0.3c0.3,0,0.5-0.1,0.8-0.2
			C8.2,4.1,9,3.7,10,3.9c1.2,0.2,2.1,0.7,2.6,1.6c-1,0.7-1.8,1.6-1.7,3.3C11,10.3,11.9,11.2,13,11.7z"
                    />
                </g>
            </g>
        </svg>
    );
}

export default AppleIcon;
